import React, { useState } from "react";
import "./Login.css";
import { SEO } from "../../components/SEO";
import { useForm } from "react-hook-form";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../../store/authStore";
import { Loader } from "../../components/Loader/Loader";

export const Login = () => {
  const navigate = useNavigate();
  const setAuth = useAuthStore((state) => state.setAuth);

  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const response = await axios.post(
        "https://htj5xy3nrv.us-east-1.awsapprunner.com/api/nCount/user/uloggedin-login",
        data
      );
      const token = response.data.token;

      await axios.post(`${process.env.REACT_APP_BASE_URL}/user/signup`, {
        username: response.data.user.name,
        phoneNumber: data.phoneNumber,
        token: token,
      });

      localStorage.setItem("phoneNumber", data.phoneNumber);
      setAuth(token);
      navigate("/home");
    } catch (err) {
      toast.error(
        err.response?.data === "user is not registered!"
          ? "You are not registered, please register first!"
          : err.response?.data?.message || "Login failed"
      );
    } finally {
      setLoading(false);
      reset();
    }
  };

  return (
    <>
      {loading && <Loader />}
      <div className="login-main-section">
        <SEO
          title="Bark Validation | Login"
          description="Welcome to the Login page of my app."
        />
        <div className="login-form-container">
          <form
            className="login-form-section"
            onSubmit={handleSubmit(onSubmit)}
          >
            <h2>Login</h2>
            <input
              type="number"
              id="phoneNumber"
              name="phoneNumber"
              placeholder="Enter Phone Number"
              onWheel={(e) => e.target.blur()}
              {...register("phoneNumber", { required: true })}
              className={`input-field ${
                errors.phoneNumber ? "error-para" : ""
              }`}
            />
            <input
              type="password"
              id="password"
              name="password"
              placeholder="Enter your PIN"
              {...register("password", {
                required: true,
              })}
              className={`input-field ${errors.password ? "error-para" : ""}`}
            />
            <button className="login-btn" type="submit">
              {isSubmitting ? "Validating..." : "Login"}
            </button>

            <a
              href="https://authenticator.ulogged.in/forgot-password"
              target="_blank"
              rel="noopener noreferrer"
              className="frgt-pass-link"
            >
              <p>Forgot Password?</p>
            </a>
            <a
              href="https://authenticator.ulogged.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="register-lnk-btn"
            >
              Register
            </a>
          </form>
        </div>
      </div>
    </>
  );
};
